import { post } from '@va/http-client';
import { ApiOperators, Where } from '@va/types/filters';
import { DateRange, PaginatedResponse, Sorting, SortingDirection } from '@va/types/requests';
import { Pagination } from '@va/types/table';

export enum WebsiteEventType {
  VisitLimitReached = 'visit_limit_reached',
  PeriodicTopicClassificationCompleted = 'periodic_topic_classification_completed',
}

export type WebsiteEvent = {
  id: string;
  websiteKey: string;
  type: WebsiteEventType;
  platform: string;
  payload: Record<string, unknown>;
  createdAt: string;
};

type WebsiteEventsParams = {
  where?: Where;
  order?: Sorting<keyof WebsiteEvent>[];
  pagination?: Pagination;
};

type WebsiteEventsPayload = WebsiteEventsParams & {
  dateRange: DateRange;
};

export const fetchWebsiteEvents = (websiteId: string, payload: WebsiteEventsPayload) =>
  post<PaginatedResponse<WebsiteEvent[]>>(`/v2/websites/${websiteId}/events`, {}, payload);

export const buildVisitLimitReachedPayload = (dateRange: DateRange): WebsiteEventsPayload => ({
  where: {
    and: [{ member: 'type', operator: ApiOperators.eq, values: [WebsiteEventType.VisitLimitReached] }],
  },
  dateRange,
  order: [{ member: 'createdAt', direction: SortingDirection.Desc }],
  pagination: { page: 1, pageSize: 100 },
});

export const buildTopicClassificationCompletedPayload = (
  dateRange: DateRange,
  pageSize: number,
): WebsiteEventsPayload => ({
  where: {
    and: [
      {
        member: 'type',
        operator: ApiOperators.eq,
        values: [WebsiteEventType.PeriodicTopicClassificationCompleted],
      },
    ],
  },
  dateRange,
  order: [{ member: 'createdAt', direction: SortingDirection.Desc }],
  pagination: { page: 1, pageSize },
});
